import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSignalRContext } from 'src/shared/contexts/signalRProvider';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { SignalRMessageTypeEnum } from 'src/shared/models/enums/signalRMessageType.enum';
import { ExportButtonEnum } from 'src/shared/models/enums/exportButton.enum';
import { useExportLockHandler } from 'src/shared/functions/exportLockHandler';
import { SignalRToastMessage } from './signalRToastMessage';

export type SignalRExtraData = {
  missionId: number;
  sessionId: number;
};

export const SignalRMessageHandler = () => {
  const signalR = useSignalRContext();
  const { unlockExportBtn } = useExportLockHandler();

  const handleMessage = (message: string, messageType: SignalRMessageTypeEnum, data?: SignalRExtraData) => {
    ConsoleHelper.log('SignalRMessageHandler', messageType, message, data);
    const { toastSettings, toastMessage } = SignalRToastMessage(messageType, message, data);
    toast(toastMessage, { ...toastSettings });
  };

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveDepositsCSVFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveDepositsCSVFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveSnapshotCSVFile}`,
    (message) => {
      unlockExportBtn(ExportButtonEnum.StatisticMemberRegisterExport);
      handleMessage(message, SignalRMessageTypeEnum.ReceiveSnapshotCSVFile);
    },
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveBookKeepingXLSXFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveBookKeepingXLSXFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveAddressLabelsPDFFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveAddressLabelsPDFFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveMembersCSVFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveMembersCSVFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveBookKeepingSIEFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveBookKeepingSIEFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveMemberListPDFFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveMemberListPDFFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.ReceiveAutogiroMandateFile}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.ReceiveAutogiroMandateFile),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.CreateMemberInvoicesDone}`,
    (message, id) => handleMessage(message, SignalRMessageTypeEnum.CreateMemberInvoicesDone, id),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.CreateInvoiceRemindersDone}`,
    (message, id) => handleMessage(message, SignalRMessageTypeEnum.CreateInvoiceRemindersDone, id),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.SendSendingsByMissionIdDone}`,
    (message, data: SignalRExtraData) => handleMessage(message, SignalRMessageTypeEnum.SendSendingsByMissionIdDone, data),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.MemberImportDone}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.MemberImportDone),
    [],
  );

  signalR.useSignalREffect(
    `${SignalRMessageTypeEnum.MemberImportRejectDone}`,
    (message) => handleMessage(message, SignalRMessageTypeEnum.MemberImportRejectDone),
    [],
  );

  useEffect(() => {
    ConsoleHelper.log('SignalR changed', signalR);
  }, [signalR]);

  return null; // or return <div>Some UI here</div>;
};
